export default __webpack_public_path__ + "static/media/gardening.830c8275.png";